const logos = {
  continued_icon:
        "https://assets-atlas-production.continued.com/static/signatures/continued_emailsig.jpg",
  ao_icon: "https://assets-atlas-production.continued.com/static/signatures/AO_emailsig.png",
  sp_icon: "https://assets-atlas-production.continued.com/static/signatures/SP_emailsig.png",
  ot_icon: "https://assets-atlas-production.continued.com/static/signatures/OT_emailsig.png",
  pt_icon: "https://assets-atlas-production.continued.com/static/signatures/PT_emailsig.png",
  simucase_icon:
    "https://assets-atlas-production.continued.com/static/signatures/simucase_emailsig.png",
  lacalle_icon:
    "https://assets-atlas-production.continued.com/static/signatures/LCG_emailsig.png"
};

export default {
    socialIcons: {
        facebook: 'https://assets-atlas-production.continued.com/static/signatures/Facebook.png',
        twitter: 'https://assets-atlas-production.continued.com/static/signatures/Twitter.png',
        facebook_continued: 'https://assets-atlas-production.continued.com/static/signatures/facebooksmall.png',
        twitter_continued: 'https://assets-atlas-production.continued.com/static/signatures/xsmall-grey.png',
        linkedin_continued: 'https://assets-atlas-production.continued.com/static/signatures/linkedinsmall.png',
    },
    siteAO: {
        heading: `<image src="${logos.ao_icon}" alt="AudiologyOnline" />`,
        email: '@audiologyonline.com',
        phone: '800.753.2160',
        address: '2028 E Ben White Blvd #240-8855<br />Austin, TX 78741<br />',
        url_text: 'www.audiologyonline.com',
        url: 'https://www.audiologyonline.com',
        facebook: 'https://www.facebook.com/audiologyonline?v=wall',
        twitter: 'https://x.com/audiologyonline',
    },
	siteSP: {
        heading: `<image src="${logos.sp_icon}" alt="SpeechPathology" />`,
        email: '@speechpathology.com',
        phone: '800.242.5183',
        address: '2028 E Ben White Blvd #240-8855<br />Austin, TX 78741<br />',
        url_text: 'www.speechpathology.com',
        url: 'https://www.speechpathology.com',
        facebook: 'https://www.facebook.com/speechpathologycom?v=wall',
        twitter: 'https://x.com/speechpathology',
    },
	siteOT: {
        heading: `<image src="${logos.ot_icon}" alt="OccupationalTherapy" />`,
        email: '@occupationaltherapy.com',
        phone: '866.782.9924',
        address: '2028 E Ben White Blvd #240-8855<br />Austin, TX 78741<br />',
        url_text: 'www.occupationaltherapy.com',
        url: 'https://www.occupationaltherapy.com',
        facebook: 'https://www.facebook.com/occupationaltherapycom?v=wall',
        twitter: 'https://x.com/OTceus',
    },
	sitePT: {
        heading: `<image src="${logos.pt_icon}" alt="PhysicalTherapy" />`,
        email: '@physicaltherapy.com',
        phone: '866.782.6258',
        address: '2028 E Ben White Blvd #240-8855<br />Austin, TX 78741<br />',
        url_text: 'www.physicaltherapy.com',
        url: 'https://www.physicaltherapy.com',
        facebook: 'https://www.facebook.com/PhysicalTherapycom',
        twitter: 'https://x.com/phystherapycom',
    },
	siteContinued: {
        heading: `<image src="${logos.continued_icon}" alt="Continued" />`,
        email: '@continued.com',
        phone: '833.726.2408',
        address: '2028 E Ben White Blvd #240-8855<br />Austin, TX 78741<br />',
        url_text: 'www.continued.com',
        url: 'https://www.continued.com',
        facebook: 'https://www.facebook.com/joincontinued',
        twitter: 'https://x.com/joincontinued',
		linkedin: 'https://linkedin.com/company/continued',
    },
	siteAHM: {
        heading: '<span style="font-family:sans-serif; font-size: 17pt; color: rgb(2, 152, 215);">Allied</span>&nbsp;<span style="font-family:sans-serif; font-size: 17pt; color: rgb(89, 65, 151);">Health</span>&nbsp;<span style="font-family:sans-serif; font-size: 17pt; color: rgb(148, 155, 161);">Media</span>',
        email: '@alliedhealthmedia.com',
        phone: '888.698.2913',
        address: '2028 E Ben White Blvd #240-8855<br />Austin, TX 78741<br />',
    },
    siteAll: {
        heading: `<image src="${logos.continued_icon}" alt="Continued" />`,
        sitesList: 'AudiologyOnline, Counseling, Early Childhood Education, OccupationalTherapy.com,<br/> PhysicalTherapy.com, Psychology, Respiratory Therapy, Social Work, SpeechPathology.com',
        email: '@continued.com',
        phone: '833.726.2408',
        address: '2028 E Ben White Blvd #240-8855<br />Austin, TX 78741<br />',
        url_text: 'www.continued.com',
        url: 'https://www.continued.com',
        facebook: 'https://www.facebook.com/joincontinued',
        twitter: 'https://x.com/joincontinued',
        linkedin: 'https://linkedin.com/company/continued',
    },
    siteSimucase: {
        heading: `<image src="${logos.simucase_icon}" width="270" alt="Simucase" />`,
        email: '@simucase.com',
        phone: '855.747.9547',
        address: '2028 E Ben White Blvd #240-8855<br />Austin, TX 78741<br />',
        url_text: 'www.simucase.com',
        url: 'https://www.simucase.com',
        facebook: 'https://www.facebook.com/Simucase',
        twitter: 'https://x.com/SimuCase',
        linkedin: 'https://linkedin.com/company/simucase',
    },
    siteLacalle: {
        heading: `<image src="${logos.lacalle_icon}" height="40" alt="Lacalle Group" />`,
        email: '@lacallegroup.com',
        phone: '888.698.2913',
        address: '2028 E Ben White Blvd #240-8855<br />Austin, TX 78741<br />',
        url_text: 'www.lacallegroup.com',
        url: 'https://www.lacallegroup.com',
        facebook: '',
        twitter: '',
    }
};